//
// Presentational side-menu notice button (sits just above Help). A teal-framed
// menu entry with a glowing dot that, when clicked, opens a small popup (shared
// chrome with the tutorials list) offering a primary action and a dismiss. It
// holds no logic about WHAT to show — SideMenu decides and passes the copy and
// the two callbacks.
//

import PropTypes from 'prop-types';
import { useState } from 'react';

import { Button } from './buttons';
import SideMenuButtonPopup from './SideMenuButtonPopup';
import SvgColorImg from './SvgColorImg';

function SideMenuNotif({
  icon, label, title, body, dismissLabel, onPrimary, onDismiss,
}) {
  const [anchorRect, setAnchorRect] = useState(null);

  const close = () => setAnchorRect(null);

  const toggle = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setAnchorRect((cur) => (cur ? null : rect));
  };

  const handlePrimary = () => {
    onPrimary();
    close();
  };

  const handleDismiss = () => {
    onDismiss();
    close();
  };

  return (
    <>
      <button
        type="button"
        data-sidemenu-notif
        onClick={toggle}
        className="w-full flex flex-row gap-4 items-center justify-start relative py-2 my-1 text-left text-pxTxt bg-transparent border-0 cursor-pointer fill-pxTxt"
      >
        {/* Teal frame, aligned with the page-entry background (ml-3), rounded on */}
        {/* the left; the my-1 above gives it vertical breathing room. */}
        <div className="absolute top-0 left-0 ml-3 h-full w-full bg-pxHelpLight rounded-l-md pointer-events-none" />

        <span className="relative ml-7 shrink-0 z-10">
          <SvgColorImg
            className="object-contain w-5 h-5 fill-pxTxt"
            src={icon}
            description={label}
            imgColorAsCssFill
          />

          <span className="absolute -top-1 -left-0.5 w-2 h-2 rounded-full px-glow-dot" />
        </span>

        <p className="truncate z-10 font-semibold">{label}</p>
      </button>

      {anchorRect
        ? (
            <SideMenuButtonPopup
              anchorRect={anchorRect}
              onClose={close}
              keepOpenSelector="[data-sidemenu-notif]"
              title={title}
            >
              {body
                ? (
                    <p className="text-sm whitespace-normal max-w-xs px-1 pb-2">
                      {body}
                    </p>
                  )
                : null}

              <div className="flex flex-row gap-2 justify-end px-1 pt-1">
                <Button
                  label={dismissLabel}
                  onClick={handleDismiss}
                  neutralColor
                />
                <Button
                  label={label}
                  imgSrc={icon}
                  onClick={handlePrimary}
                  baseColor
                />
              </div>
            </SideMenuButtonPopup>
          )
        : null}
    </>
  );
}

SideMenuNotif.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  dismissLabel: PropTypes.string,
  onPrimary: PropTypes.func,
  onDismiss: PropTypes.func,
};

export default SideMenuNotif;
